<template>
  <div>
    <topsearch title="Teklif Şablonu üretici" />

    <div class=" md:p-4">
      <div>
        <form @submit.prevent="submitBid">
          <div
            class="
              flex 
              w-full
              space-x-2
              mb-2
              items-end
              justify-between
            "
          >
            <div>
              <button
                type="submit"
                class="green-button
                "
              >
                Teklif Şablonu Kaydet
              </button>
            </div>
          </div>
          <div
            v-for="(question, index) in Bid.questions"
            :key="index"
            class="border   rounded-lg shadow-b mb-2"
          >
            <div
              class="
                flex
                w-full
                p-2
                border-t-2
                space-x-2
                border-tile-400
                rounded-lg
                items-end
                justify-between
              "
            >
              <div class="flex-1">
                <label for="questionText">Soru {{ index + 1 }}:</label>
                <input
                  type="text"
                  id="questionText"
                  class="uk-input"
                  v-model="question.text"
                />
              </div>
              <div>
                <label>Bağlanacak Alan: </label>
                <select class="global-button" v-model="question.type">
                  <option value="db">Veritabanındaki bir alana bağla</option>
                  <option value="cat">Seçenekli fiyat</option>
                </select>
                <select
                  class="global-button"
                  v-if="question.type == 'db'"
                  v-model="question.field"
                >
                  <option
                    :value="{ id: component.id, name: component.name }"
                    v-for="component in components"
                  >
                    {{ component.display_name }}
                  </option>
                </select>
              </div>
              <div>
                <button
                  @click.prevent="deleteQuestion(index)"
                  class="
                    bg-red-500
                    flex
                    items-center
                    justify-between
                    space-x-1
                    text-primary-50
                    px-2
                    py-1
                    rounded
                  "
                >
                  <svg
                    alt="Soruyu sil"
                    title="Soruyu sil"
                    class="w-6 h-6"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8z"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div class="p-2">
              <div
                v-if="question.type == 'cat' || question.type == 'formule'"
                class="flex items-center justify-start"
              >
                <div class="grid grid-cols-4 w-full gap-2">
                  <div
                    v-for="(answer, answerIndex) in question.answers"
                    :key="answerIndex"
                  >
                    <label for="answerText"
                      >Seçenek {{ answerIndex + 1 }}:</label
                    >
                    <input
                      type="text"
                      id="answerText"
                      class="w-full uk-input"
                      v-model="answer.text"
                    />
                    <label
                      >Fiyatı etkiler
                      <input type="checkbox" v-model="answer.priceCalc"
                    /></label>
                    <input
                      type="text"
                      v-if="answer.priceCalc"
                      id="answerText"
                      class="w-full uk-input"
                      v-model="answer.priceVal"
                    />
                  </div>
                </div>
              </div>
              <div class="flex mt-2 space-x-2">
                <button
                  v-if="question.type == 'cat' || question.type == 'formule'"
                  @click.prevent="addAnswer(index)"
                  class="
                  primary-button
                  "
                >
                  Seçenek ekle
                </button>
              </div>
            </div>
          </div>

          <div>
            <h3 class="p-0 m-0 text-lg">Yeni Soru</h3>
            <div class="flex space-x-2 items-end">
              <label>
                Cevap Türü:
                <select class="global-button" v-model="questionType">
                  <option value="db">Veritabanındaki bir alana bağla</option>
                  <option value="cat">Seçenekli fiyat</option>
                </select>
              </label>
              <button
                @click.prevent="addQuestion()"
                class="
                primary-button
                "
              >
                Soru Ekle
              </button>
            </div>
          </div>
        </form>
      </div>

      <div></div>
    </div>
  </div>
</template>

<script>
import http from "../services/http";
export default {
  data() {
    return {
      questionType: "db",
      components: [],
      Bid: {
        name: "",
        questions: [
          {
            type: "db",
            text: "",
            answers: [
              {
                text: ""
              }
            ]
          }
        ]
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      http
        .getData({
          table: "leads"
        })
        .then(resp => {
          this.components = resp.data.components;
        });
    },
    addQuestion() {
      this.Bid.questions.push({
        text: "",
        type: this.questionType,
        answers: [
          {
            text: ""
          }
        ]
      });
    },
    addAnswer(index) {
      this.Bid.questions[index].answers.push({
        text: ""
      });
    },
    deleteQuestion(index) {
      this.Bid.questions.splice(index, 1);
    },
    async submitBid() {
      try {
        http.bidsSave(this.Bid).then(resp => {
          this.$root.successMessage("İşlem başarıyla kaydedildi");
        });
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>
